/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { smallScreen } from '../../../../common/mixins';

const iconRules = ({ size }) => ({
  // eslint-disable-next-line no-nested-ternary
  height: size === 'small' ? '1.5em' : (size === 'large' ? '10em' : '2.2rem'),
  extend: [
    smallScreen({
      // eslint-disable-next-line no-nested-ternary
      height: size === 'small' ? '1.5em' : (size === 'large' ? '6em' : '2.2rem'),
    }),
  ],
});

const ConnectedIcon = ({ size }) => {
  const { css } = useFela({ size });

  return (
    <svg className={css(iconRules)} viewBox="0 0 24 24">
      <g stroke="none" fill="none">
        <path d="M1,18 L1,21 L4,21 C4,19.34 2.66,18 1,18 L1,18 Z M1,14 L1,16 C3.76,16 6,18.24 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z M19,7 L5,7 L5,8.63 C8.96,9.91 12.09,13.04 13.37,17 L19,17 L19,7 L19,7 Z M1,10 L1,12 C5.97,12 10,16.03 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z" fill="currentColor" />
      </g>
    </svg>
  );
};

ConnectedIcon.propTypes = {
  size: PropTypes.string,
};

export default ConnectedIcon;
